<!-- ************************new-branding-supplier-onboarding************************************ -->
<div class="content col-md-10 container-fluid" [formGroup]="capabilityDetailsForm">
    <br>
    <div class=" static container-fluid mr-0 ml-0 pl-0">
        <img src="assets/svg/Page 2.svg" alt="">
    </div>
    <div class="container-fluid progress-heading row mt-3 mr-0 ml-0">
        <div class="col-md-3 pr-0 pl-0 ">
            <h6 class="text-center step pr-5">Step 1</h6>
            <h6 class="text-center info">General Information</h6>
        </div>
        <div class="col-md-3 pl-0 pr-0 ">
            <h6 class="text-center step pr-4">Step 2</h6>
            <h6 class="text-center info ">Capabilities</h6>
        </div>
        <div class="col-md-3 pr-0 pl-0">
            <h6 class="text-center step inactive">Step 3</h6>
            <h6 class="text-center info inactive">Terms & Conditions</h6>
        </div>
        <div class="col-md-3 pr-0 pl-0">
            <h6 class="text-center step inactive">Step 4</h6>
            <h6 class="text-center info inactive">Completed</h6>
        </div>
    </div>
    <br>
    <br>
    <h6 class="page-head">Capabilities</h6>
    <hr class="hr-one">
    <div class="sub-head row mr-0 ml-0">
        <div class="number">
            <p class="mb-0 semi-bold">1</p>
        </div>
        <div class="ml-4">
            <h6 class="mb-0">Manufacturing</h6>
        </div>
    </div>
    <div class="detail">
        <p class="print"><span style="color: #ff0000;">*</span>&nbsp;Mention the parts which you specialize in? (e.g. Gear Boxes, Disc Brakes)</p>
        <div class="parts-table custom-form" formArrayName="vendor_works_attributes">
            <table class="container-fluid">
                <tr>
                    <th style="border-left: 1px solid #D0D0CE;">NO.</th>
                    <th>Name</th>
                    <th style="border-right: 1px solid #D0D0CE;">Action</th>
                </tr>
                <tr *ngFor="let item of capabilityDetailsForm.get('vendor_works_attributes')['controls']; let i = index" [formGroupName]="i">
                    <td class="col-md-2">{{i+1}}</td>
                    <td class="col-md-8">

                        <input type="text" class="parts-input" formControlName="wp_name">
                    </td>
                    <td class="pointer col-md-2" style="color: #ff6900;" (click)="removeVendorWork(i)">Delete</td>
                </tr>
            </table>
        </div>
    </div>
    <br>
    <button class="green-button" (click)="addVendorWork()">Add More</button>
    <hr class="hr-two">
    <div class="sub-head row mr-0 ml-0">
        <div class="number">
            <p class="mb-0 semi-bold">2</p>
        </div>
        <div class="ml-4">
            <h6 class="mb-0">Design & Softwares</h6>
        </div>
    </div>
    <div class="container-fluid  ml-0 mr-0 pl-0">
        <h6 class=" design question"><span style="color: #ff0000;">*</span> Do you have in-house design & analysis capability?</h6>
        <div *ngFor="let item of vendorDesigns">
            <mat-checkbox (change)="onchangeVendorDesignValue($event, item)" [value]="item.id" [checked]="item.is_checked" class="mb-3" color="warn"><span class="checkbox-label">{{item.display_name}}</span></mat-checkbox><br>
        </div>

    </div>
    <div class="container-fluid ml-0 mr-0 pl-0 mt-4">
        <h6 class="question software"><span style="color: #ff0000;">*</span> What Kind of Software Does your Company use ?</h6>
        <div *ngFor="let item of vendorSoftwares">
            <mat-checkbox [value]="item.id" [checked]="item.is_checked" (change)="onchangeVendorSoftwareValue($event, item)" class="mb-3" color="warn"><span class="checkbox-label">{{item.display_name}}</span></mat-checkbox><br>
        </div>
        <input *ngIf="showNewVendorSoftwareInput" [ngModel]="" placeholder="'Please provide name(s)'" formControlName="new_vendor_softwares" class="other mt-3" type="text" placeholder="Type here">
    </div>
    <hr class="hr-three">
    <div class="sub-head manufacturing row mr-0 ml-0">
        <div class="number">
            <p class="mb-0 semi-bold">3</p>
        </div>
        <div class="ml-4">
            <h6 class="mb-0">Manufacturing Capabilities</h6>
        </div>
    </div>
    <div class="container-fluid mr-0 ml-0 pl-0 mt-4 mb-4">
        <h6 class="question mb-3"><span style="color: #ff0000;">*</span> Which manufacturing sub-processes can you undertake?</h6>
        <ng-multiselect-dropdown [data]="printProcesses" formControlName="selectedPrintProcesses" [settings]="printProcessDropdownSettings" (onSelect)="onPrintProcessSelect($event)" (onDeSelect)="onPrintProcessDeselect($event)">
        </ng-multiselect-dropdown>
        <div class="mr-0 ml-0 container-fluid ">
            <div class="row add-option">
                <p class="mb-0 col-md-10">Didn’t find it?</p>
                <a class="text-right mb-0 col-md-2 pointer" (click)="newPrintProcess()">Add New option</a>
            </div>
        </div>
    </div>
    <br>
    <h6 class="finish mt-5">Finishing/surface treatment capabilities</h6>
    <h6 class="question process"><span style="color: #ff0000;">*</span> Which Post Processes you can perform on your shop floor?</h6>
    <br>
    <ng-multiselect-dropdown [data]="vendorPostProcesses" formControlName="selectedPostProcesses" [settings]="vendorPostProcessSettings" (onSelect)="onPostProcessSelect($event)" (onDeSelect)="onPostProcessDeselect($event)">
    </ng-multiselect-dropdown>
    <div class="mr-0 ml-0 container-fluid ">
        <div class="row add-option">
            <p class="mb-0 col-md-10">Didn’t find it?</p>
            <a class="text-right mb-0 col-md-2 pointer" (click)="newPostProcess()">Add New option</a>
        </div>
    </div>
    <hr class="hr-four">
    <div class="sub-head row mr-0 ml-0">
        <div class="number">
            <p class="mb-0 semi-bold">4</p>
        </div>
        <div class="ml-4">
            <h6 class="mb-0">Machines Information</h6>
        </div>
    </div>
    <div class="container-fluid mr-0 mb-0 pl-0">
        <h6 class="finish machine-type"><span style="color: #ff0000;">*</span>Select Type of machine setup ?</h6>
        <!-- <div class="machines row col-md-12">
            <div class="technology " *ngFor="let item of manufacturingTechnologies;">
                <div class="image">
                    <img *ngIf="item.name == 'Sheet Metal Manufacturing'" src="assets/svg/Sheet metal.svg" alt="">
                    <img *ngIf="item.name == '3D Printing'" src="assets/svg/3D Print.svg" alt="">
                    <img *ngIf="item.name == 'Casting/Forging'" src="assets/svg/Metal Casting.svg" alt="">
                    <img *ngIf="item.name == 'CNC Machining'" src="assets/svg/CNC Machine.svg" alt="">
                    <img *ngIf="item.name == 'Injection Molding'" src="assets/svg/Injection Moding.svg" alt="">
                    <img *ngIf="item.name == 'Vacuum Casting'" src="assets/svg/Vacuum Casting 2.svg" alt="">
                    <p class="mb-0 text-center name">{{item.name}}</p>
                </div>
                <button (click)="selectMachineTechnology(item)" class="add-machine mt-3">Add Machine</button>
                <br>
                <br>
            </div>
        </div> -->
        <div class="machines row mr-0 ml-0">
            <div class="technology">
                <div class="image pointer">
                    <img src="assets/svg/Sheet metal.svg" alt="">
                    <p class="mb-1 text-center name">Sheet Metal</p>
                    <p class="mb-2 text-center name">Manufacturing</p>
                </div>
                <button value="Sheet Metal Manufacturing" (click)="selectMachineTechnology($event.target.value)" class="add-machine mt-3">Add Machine</button>
            </div>
            <div class="technology">
                <div class="image pointer">
                    <img src="assets/svg/3D Print.svg" alt="">
                    <p class="mb-1 text-center name">3D Printing</p>
                </div>
                <button value="3D Printing" (click)="selectMachineTechnology($event.target.value)" class="add-machine mt-3">Add Machine</button>
            </div>
            <div class="technology">
                <div class="image pointer">
                    <img src="assets/svg/Metal Casting.svg" alt="">
                    <p class="mb-1 text-center name">Metal Casting</p>
                </div>
                <button value="Casting/Forging" (click)="selectMachineTechnology($event.target.value)" class="add-machine mt-3">Add Machine</button>
            </div>
            <div class="technology">
                <div class="image pointer">
                    <img src="assets/svg/CNC Machine.svg" alt="">
                    <p class="mb-1 text-center name">CNC Machining</p>
                </div>
                <button value="CNC Machining" (click)="selectMachineTechnology($event.target.value)" class="add-machine mt-3">Add Machine</button>
            </div>
        </div>
        <div class="machines second-row row mr-0 ml-0">
            <div class="technology">
                <div class="image pointer">
                    <img src="assets/svg/Injection Moding.svg" alt="">
                    <p class="mb-1 text-center name">Injection Molding</p>
                </div>
                <button value="Injection Molding" (click)="selectMachineTechnology($event.target.value)" class="add-machine mt-3">Add Machine</button>
            </div>
            <div class="technology">
                <div class="image pointer">
                    <img src="assets/svg/Vacuum Casting 2.svg" alt="">
                    <p class="mb-1 mt-1 text-center name">Vacuum Casting</p>
                </div>
                <button value="Vacuum Casting" (click)="selectMachineTechnology($event.target.value)" class="add-machine mt-3">Add Machine</button>
            </div>
        </div>
    </div>
    <div *ngIf="machineDetailsArray.length == 0" class="container-fluid mr-0 ml-0 pl-0 no-machines">
        <p class="mb-0 pl-3">No Machines found ! Please add one.</p>
    </div>
    <br>
    <div class="machines-table" *ngIf="machineDetailsArray.length > 0">
        <h6 class="list-head">List of Added Machine Details</h6>
        <table class="container-fluid">
            <tr>
                <th class="col-md-1" style="border-left: 1px solid #5D5D5D;">No</th>
                <th class="col-md-1">Type</th>
                <th class="col-md-1">Brand</th>
                <th class="col-md-1">Model</th>
                <th class="col-md-2">Capacity/ Specifications</th>
                <th class="col-md-1">Qty.</th>
                <th class="col-md-2">Monthly Spare Capacity</th>
                <th class="col-md-1">Action</th>
            </tr>
            <tr *ngFor="let item of machineDetailsArray; let i= index">
                <td class="bold">{{i+1}}</td>
                <td>{{item?.manufacturing_technology_name}} <br> ({{item.vendor_machine_name}})</td>
                <td>{{item?.brand_name}}</td>
                <td>{{item?.model_number}}</td>
                <td>
                    <div *ngFor="let spec of item.vom_specifications">
                        <p class="mb-0 mt-2">{{spec?.master_specification_name? spec?.master_specification_name:'--'}}</p>
                        <p class="mb-0 mt-2">
                            <span *ngIf="spec?.master_specification_name =='Support brackets' && spec?.machine_capacity == true">{{spec?.machine_capacity? '':'--'}}&nbsp;&nbsp;</span>
                            <span *ngIf="spec?.master_specification_name !='Support brackets' && spec?.machine_capacity != true">{{spec?.machine_capacity? spec?.machine_capacity:'--'}}&nbsp;&nbsp;</span>
                            <span *ngIf="spec.machine_specification_unit_name != 'n/a'">{{spec?.machine_specification_unit_name? spec?.machine_specification_unit_name:'--'}}</span>
                            <span *ngIf="spec?.master_specification_name == 'Marking Possible' && spec?.machine_capacity == true ">Yes</span>
                            <span *ngIf="spec?.master_specification_name =='Support brackets' && spec?.machine_capacity == true">Yes</span>
                        </p>
                    </div>
                </td>
                <td>{{item?.number_of_machines}}</td>
                <td>{{item?.spare_capacity}}&nbsp;%</td>
                <td class="pointer" style="color: #ff6900;"><img (click)="editFromMachineArray(item,i)" src="assets/svg/Edit icon.svg" alt="">&nbsp;&nbsp;&nbsp;&nbsp;<img src="assets/svg/Delete Icon.svg" alt="" (click)="deleteFromMachineArray(i)"></td>
            </tr>
        </table>
    </div>
    <hr class="hr-five">
    <div class="sub-head row mr-0 ml-0 ">
        <div class="number">
            <p class="mb-0 semi-bold">5</p>
        </div>
        <div class="ml-4">
            <h6 class="mb-0">Industry Verticals & Clients</h6>
        </div>
    </div>
    <div class="container-fluid mr-0 mb-0 pl-0">
        <h6 class="question verticals "><span style="color: #ff0000;">*</span> Select the industry Verticals you are Specialized working with </h6>
        <ng-multiselect-dropdown [data]="vendorIndustries" formControlName="selectedVendorIndustries" [settings]="industryDropdownSettings" (onSelect)="onIndustrySelect($event)" (onDeSelect)="onIndustryDeselect($event)">
        </ng-multiselect-dropdown>
        <div class="mr-0 ml-0 container-fluid ">
            <div class="row add-option">
                <p class="mb-0 col-md-10">Didn’t find it?</p>
                <a class="text-right mb-0 col-md-2 pointer" (click)="newIndustry()">Add New option</a>
            </div>
        </div>
    </div>
    <br>
    <div class="industry-table" formArrayName="vendor_industries_clients_attributes">
        <h6 class="list-head">Your major clients with respect to industries</h6>
        <table class="container-fluid">
            <tr>
                <th class="col-md-1" style="border-left: 1px solid #5D5D5D;">No</th>
                <th class="col-md-2">Industry Name</th>
                <th class="col-md-3">Client Names *</th>
                <th class="col-md-1" style="border-right: 1px solid #5D5D5D;">Action</th>
            </tr>
            <tr *ngFor="let item of capabilityDetailsForm.get('vendor_industries_clients_attributes')['controls']; let i = index" [formGroupName]="i">
                <td>{{i+1}}</td>
                <td class="col-md-2">{{item.controls['industry_name'].value}}</td>
                <td class="custom-form col-md-3">
                    <span class="form-error-text onboarding-span" *ngIf="capabilityDetailsFormSubmitted && capabilityDetailsForm.get('vendor_industries_clients_attributes')['controls'][i].get('client_name').errors?.required">*Atleast 1 client is required</span>
                    <input class="parts-input" formControlName="client_name" type="text" placeholder="Ex. Mahindra, Tata">
                </td>
                <td class="pointer" style="color: #ff6900; font-size: 16px;" (click)="removeMasterClient(i)">Delete</td>
            </tr>
        </table>
    </div>
    <hr class="hr-five">
    <div class="sub-head row mr-0 ml-0">
        <div class="number">
            <p class="mb-0 semi-bold">6</p>
        </div>
        <div class="ml-4">
            <h6 class="mb-0">Quality Assurance Information</h6>
        </div>
    </div>
    <div class="container-fluid mr-0 ml-0 pl-0 ">
        <h6 class="question quality mb-3"><span style="color: #ff0000;">*</span> Do you have a dedicated quality inspection department?</h6>
        <div>
            <mat-radio-group formControlName="quality_inspection_department">
                <mat-radio-button name="quality_inspection_department" [value]="true" (change)="onChangeQualityInpection(true)" class="col-md-2" color="warn"><span class="checkbox-label">Yes</span></mat-radio-button>
                <mat-radio-button name="quality_inspection_department" [value]="false" (change)="onChangeQualityInpection(false)" color="warn"><span class="checkbox-label">No</span></mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    <div class="quality-table" formArrayName="vendor_quality_instruments_attributes">
        <h6 class="list-head" *ngIf="measuring_instrument_table">Enter measuring instrument details below</h6>
        <table class="container-fluid" *ngIf="measuring_instrument_table">
            <tr>
                <th class="col-md-1" style="border-left: 1px solid #5D5D5D;">No</th>
                <th><span style="color: #ff0000;">*</span> Instrument Name</th>
                <th><span style="color: #ff0000;">*</span> Brand Name</th>
                <th><span style="color: #ff0000;">*</span> Size & Capacity</th>
                <th><span style="color: #ff0000;">*</span> Quantity</th>
                <th class="col-md-1" style="border-right: 1px solid #5D5D5D;">Action</th>
            </tr>
            <tr style="height: 85px;" *ngFor="let item of capabilityDetailsForm.get('vendor_quality_instruments_attributes')['controls']; let i = index" [formGroupName]="i">
                <td>{{i+1}}</td>
                <td class="custom-form">
                    <div class="mr-0 ml-0">
                        <span style="font-size: 14px;" class="form-error-text onboarding-span mt-0 mb-0" *ngIf="capabilityDetailsFormSubmitted && capabilityDetailsForm.get('vendor_quality_instruments_attributes')['controls'][i].get('quality_instrument_name').errors?.required">*Required</span>
                        <ng-autocomplete [data]="instruments" [searchKeyword]="keyword" (inputChanged)='onChangeInstrumentSearch($event)' [itemTemplate]="itemTemplate" class="autocomplete-container pl-0" formControlName="quality_instrument_name">
                        </ng-autocomplete>
                        <ng-template #itemTemplate let-item>
                            <a [innerHTML]="item.display_name"></a>
                        </ng-template>
                    </div>
                </td>
                <td class="custom-form">
                    <div class="mr-0 ml-0">
                        <span style="font-size: 14px;" class="form-error-text onboarding-span" *ngIf="capabilityDetailsFormSubmitted && capabilityDetailsForm.get('vendor_quality_instruments_attributes')['controls'][i].get('brand_name').errors?.required">*Brand is required</span>
                        <ng-autocomplete [data]="brands" [searchKeyword]="keyword" (inputChanged)='onChangeBrandSearch($event)' [itemTemplate]="itemTemplate" formControlName="brand_name">
                        </ng-autocomplete>
                        <ng-template #itemTemplate let-item>
                            <a [innerHTML]="item.display_name"></a>
                        </ng-template>
                    </div>
                </td>
                <td class="custom-form">
                    <div class="row mr-0 ml-0">
                        <span class="form-error-text onboarding-span" *ngIf="capabilityDetailsFormSubmitted && capabilityDetailsForm.get('vendor_quality_instruments_attributes')['controls'][i].get('size').errors?.required">*Size is required</span>
                        <input type="text" class="col-md-8 mr-2" formControlName="size">
                        <select class=" col-md-3 select arrow-img" style="padding-top: 2px;" name="" id="" formControlName="unit">
                                <option value="micrometer">um</option>
                                <option value="millimeter">mm</option>
                                <option value="centimeter">cm</option>
                                <option value="meter">m</option>
                                <option value="kilometer">km</option>
                        </select>
                    </div>
                </td>
                <td class="custom-form">
                    <span class="form-error-text onboarding-span" *ngIf="capabilityDetailsFormSubmitted && capabilityDetailsForm.get('vendor_quality_instruments_attributes')['controls'][i].get('quantity').errors?.required">*Quantity is required</span>
                    <input type="text" formControlName="quantity">
                </td>
                <td class="pointer" style="color: #ff6900; font-size: 16px;" (click)="removeQualityInstrument(i)">Delete</td>
            </tr>
        </table>
    </div>
    <div class="mt-4" *ngIf="measuring_instrument_table">
        <p class="mb-4 parts-input">Add Quality Instrument</p>
        <button class="green-button" (click)="addQualityInstrument()">Add More</button>
    </div>
    <hr class="hr-five">
    <div class="sub-head row mr-0 ml-0">
        <div class="number">
            <p class="mb-0 semi-bold">7</p>
        </div>
        <div class="ml-4">
            <h6 class="mb-0">Certifications</h6>

        </div>
    </div>
    <div class="container-fluid ml-0 mr-0 pl-0">
        <h6 class="certifications question"><span style="color: #ff0000;">*</span> Select the certifications you are working with</h6>
        <ng-multiselect-dropdown [data]="certificates" formControlName="selectedCertificates" [settings]="certificatesDropdownSettings" (onSelect)="onCertificatesSelect($event)" (onDeSelect)="onCertificatesDeselect($event)">
        </ng-multiselect-dropdown>
        <div class="mr-0 ml-0 container-fluid ">
            <div class="row add-option">
                <p class="mb-0 col-md-10">Didn’t find it?</p>
                <a class="text-right mb-0 col-md-2 pointer" (click)="newCertificates()">Add New option</a>
            </div>
        </div>
    </div>
    <div class="row mr-0 ml-0">
        <div class="upload-img-box mt-5">
            <div class="container-fluid" style="margin: auto;">
                <img style="display: flex;margin: auto;" class="mb-3" src="assets/svg/upload-file.svg" alt="cube">
                <p class="mb-3 ml-2 text-center col-md-10">Upload your files here (Max. file size 10 MB)</p>
                <input class="mt-3" type="file" accept=".pdf, .docs, .xls, .pptx, .jpeg, .png, .docx, .jpg" multiple (change)="onCertificationDocumentSelect($event)">
            </div>
            <br>
        </div>
        <div class="mt-5 ml-5 uploaded-certificates" *ngIf="certificationFiles.length > 0">
            <p>Uploaded Certificates</p>
            <div *ngFor="let item of certificationFiles ; let i = index">
                <p (click)="downloadCert(i)" class="mb-2 pointer">{{i+1}}&nbsp;&nbsp;&nbsp;{{item.name | titlecase}}</p>
            </div>
        </div>
    </div>
    <hr class="hr-five">
    <div class="page-button">
        <div class="col-md-6">
            <p [routerLink]="['/onboarding']" class="p-semibold pointer">
                < Back</p>
        </div>
        <div class="float-right row">
            <button class="white-button mr-2" (click)="saveMachineDraft()">Save Draft</button>
            <button class="orange-button ml-2" (click)="submitCapabilitiesDetails()">Continue</button>
        </div>
    </div>
</div>
<!--  -->
<!-- <div class="comtainer-fluid nav-data">
  <div class="container">
    <ul class="nav nav-tabs tabs">

      <li><a data-toggle="tab" routerLink="/onboarding">General Information</a></li>
      <li><a data-toggle="tab" routerLink="/onboarding/machine-details" class="active">Capabilities</a></li>
      <li><a data-toggle="tab" routerLink="/onboarding/terms">Terms and Conditions</a></li>
    </ul>
  </div>
</div>
<div class="container">
  <div class="col-md-12 set-manuf-patrner display-flex-lg">
    <div class="col-md-4 manf-text no-padding">
      <h1>Setup Manufacturing Partner Account </h1>
      <p>Let's help you get started setting up MP Account. Here are Some key things to do</p>
    </div>
    <div class="col-md-3 offset-md-1 pages-link">
      <nav class="">
        <a routerLink="/onboarding"><span>Step 1</span> Company Details</a>
        &nbsp;&nbsp;&nbsp;
        <a routerLink="/onboarding/machine-details" class="active"><span>Step 2</span> Machine Details</a>
        &nbsp;&nbsp;&nbsp;
        <a routerLink="/onboarding/terms"><span>Step 3</span> Terms and Conditions</a>
        &nbsp;&nbsp;&nbsp;
      </nav>
    </div>
  </div>

  <div class="company-profile-block col-md-12 no-padding">
    <form [formGroup]="capabilityDetailsForm" (ngSubmit)="submitCapabilitiesDetails()" class="col-md-12 no-padding">
      <h2 class="machine-details-header top-margin">Capabilities Information</h2>
      <div class="machine-details blue-box-container capabilities-info-box">
        <div class="group-gap xs-table-scroll" formArrayName="vendor_works_attributes">
          <h4 class=heading-data>Parts Manufacturing</h4>
          <h4 class=" blue-color-heading">Mention some part types whose manufacturing you specialize in ? (e.g. Gear
            Boxes, Disc Brakes)</h4>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="center">Sr</th>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of capabilityDetailsForm.get('vendor_works_attributes')['controls']; let i = index"
                [formGroupName]="i">
                <td class="center" valign="center">{{i+1}}</td>
                <td class="display-flex-lg">
                  <input type="text" class="form-control" formControlName="wp_name"
                    onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123 || event.charCode == 32)">
                  &nbsp;&nbsp;
                  <span class="remove-icon" (click)="removeVendorWork(i)">&times;</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="form-row top-margin-sm">
            <div class="col">
              <button type="button" class="btn btn-primary btn-sm" (click)="addVendorWork()">Add More</button>
            </div>
          </div>
        </div>

        <div class="col-md-12 no-padding top-margin">
          <h4 class=heading-data>Design & Softwares</h4>
          <h2 class="machine-details-header blue-color-heading no-margin-left">Do you have inhouse design & analysis
            capability ?</h2>

          <div class="col-md-12 capabilities-info no-padding">
            <div *ngFor="let item of vendorDesigns">
              <div class="col-md-4 col-12 no-padding">
                <label class="custom-container">
                  <input type="checkbox" class="auto-height" [value]="item.id" [checked]="item.is_checked"
                    (change)="onchangeVendorDesignValue($event, item)">{{item.display_name}}
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 no-padding top-margin">
          <h2 class="machine-details-header blue-color-heading  no-margin-left">What kind of Software does your company
            use?</h2>

          <div class="col-md-12 capabilities-info no-padding">
            <div *ngFor="let item of vendorSoftwares">
              <div class="col-md-4 col-12 no-padding">
                <label class="custom-container">
                  <input type="checkbox" class="auto-height" [value]="item.id" [checked]="item.is_checked"
                    (change)="onchangeVendorSoftwareValue($event, item)">{{item.display_name}}
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <div *ngIf="showNewVendorSoftwareInput" class="other-software-name tag-input">
              <tag-input [ngModel]="" [secondaryPlaceholder]="'Please provide name(s)'"
                formControlName="new_vendor_softwares" class="input-style" style>
              </tag-input>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 no-padding top-margin">

        <div class="machine-details blue-box-container capabilities-info-box">
          <h2 class="heading-data">Manufacturing Process Information</h2>
          <h4 class="blue-color-heading">Which Mfg. Processes can undertake?*</h4>
          <ng-multiselect-dropdown [data]="printProcesses" formControlName="selectedPrintProcesses"
            [settings]="printProcessDropdownSettings" (onSelect)="onPrintProcessSelect($event)"
            (onDeSelect)="onPrintProcessDeselect($event)">
          </ng-multiselect-dropdown>
          <small><a data-toggle="modal" data-target="#newPrintProcessFormModal" (click)="setNewPrintProcessForm()"
              class="new-industry-link">Didn't find your Manufacturing Industry? Click to add it.</a></small>


          <div class="col-md-12 no-padding top-margin">
            <h2 class="heading-data">Finishing/surface treatment capabilities</h2>
            <h2 class="machine-details-header blue-color-heading no-margin-left">Which Post Processes you can perform on
              your shop floor?
            </h2>

            <div class="col-md-12 capabilities-info no-padding">
              <div *ngFor="let item of vendorPostProcesses">
                <div class="col-md-4 col-12 no-padding">
                  <label class="custom-container">
                    <input type="checkbox" class="auto-height" [value]="item.id" [checked]="item.is_checked"
                      (change)="onchangeVendorPostProcessValue($event, item)">{{item.display_name}}
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div *ngIf="showNewVendorPostProcessInput" class="other-post-process-name tag-input">
                <tag-input [ngModel]="" [secondaryPlaceholder]="'Please provide name(s)'"
                  formControlName="new_post_processes" class="input-style" style>
                </tag-input>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h2 class="top-margin machine-details-header">Machine Information</h2>
      <div class="machine-details blue-box-container">
        <h2 class="heading-data">Select type of Machine Setup</h2>
        <h4 class="blue-color-heading"> *Which Post Processes you can perform on your shop floor?</h4>
        <div class=" capabilities-info-box">
          <div class="col-md-12 tech-data top-margin">
            <div *ngFor="let item of manufacturingTechnologies;" class="technology-box ">
              <div class="img-head">
                <img *ngIf="item.name == '3D Printing'" src="./assets/images/3dprinitng.png">
              </div>
              <div class="img-head">
                <img *ngIf="item.name == 'CNC Machining'" src="./assets/images/cnc_machining.png">
              </div>
              <div class="img-head">
                <img *ngIf="item.name == 'Vacuum Casting'" src="./assets/images/vaccum_casting.png">
              </div>
              <div class="img-head">
                <img *ngIf="item.name == 'Sheet Metal Manufacturing'" src="./assets/images/sheet_metal.png">
              </div>
              <div class="img-head">
                <img *ngIf="item.name == 'Injection Molding'" src="./assets/images/im.png">
              </div>
              <div class="img-head">
                <img *ngIf="item.name == 'Casting/Forging'" src="./assets/images/casting.png">
              </div>
              <p>
                {{item.name}}
                <button type="button" class="btn btn-sm add-machine" data-toggle="modal" data-target="#machineFormModal"
                  (click)="setManufacturingTechnologyData(item)"> Add machine ></button>
              </p>
            </div>

          </div>
        </div>
        <div class="col-md-12 col-sm-12 no-padding top-margin">
          <div class="col-md-12 col-sm-12 capabilities-info no-padding top-margin xs-table-scroll"
            *ngIf="machineDetailsArray.length > 0">
            <h2 class="heading-data">List of Machine Setup </h2>
            <table>
              <tr>
                <th>Technology</th>
                <th>Brand</th>
                <th>Model</th>
                <th>Machine Name/Type</th>
                <th>Machine Capacity/Specifications</th>
                <th>No of Machines</th>
                <th>Monthly Spare Capacity</th> -->
<!-- <th>Location</th> -->
<!-- <th>Delete</th>
</tr>
<tr *ngFor="let item of machineDetailsArray; let i = index">
    <td>{{item.manufacturing_technology_name}}</td>
    <td>
        {{item.brand_name}}
    </td>
    <td>
        {{item.model_number}}
    </td>
    <td>
        {{item.vendor_machine_display_name || item.vendor_machine_name}}
    </td>
    <td>
        <div *ngFor="let spec of item.vom_specifications;">
            <p *ngIf="spec.machine_capacity">
                {{spec.master_specification_name}} {{spec.machine_capacity}}
                <span *ngIf="spec.machine_specification_unit_name != 'n/a'">
                        {{spec.machine_specification_unit_name}}
                      </span>
            </p>
        </div>
    </td>
    <td>
        {{item.number_of_machines}}
    </td>
    <td>
        {{item.spare_capacity}}
    </td> -->
<!-- <td>{{item.address_name}}</td> -->
<!-- <td>
    <span class="remove-icon" (click)="deleteFromMachineArray(i)">&times;</span>
    <span data-toggle="modal" data-target="#machineFormModal" (click)="editFromMachineArray(item, i)">edit</span>
</td>
</tr>
</table>
<br>
</div>
<div class="col-md-12 col-sm-12 no-padding" *ngIf="machineDetailsArray.length == 0">
    <p>No Machines found. Please add one.</p>
</div>
</div>
</div>

<h2 class="top-margin machine-details-header">Industry Verticle</h2>
<div class="blue-box-container">

    <div class="capabilities-info  col-sm-12 no-padding">
        <div class="col-sm-8 no-padding">
            <h4 class="blue-color-heading">Select the industry Verticals you are Specialized working with</h4>
            <ng-multiselect-dropdown [data]="vendorIndustries" formControlName="selectedVendorIndustries" [settings]="industryDropdownSettings" (onSelect)="onIndustrySelect($event)" (onDeSelect)="onIndustryDeselect($event)">
            </ng-multiselect-dropdown>
            <small><a data-toggle="modal" data-target="#newIndustryFormModal" (click)="setNewIndustryForm()"
                class="new-industry-link">Didn't find your industry? Click to add it.</a></small>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-8 no-padding xs-table-scroll" formArrayName="vendor_industries_clients_attributes">
            <h4 class="top-margin-sm blue-color-heading">Your Major Clients with respect to industries</h4>

            <table>
                <tr>
                    <th>Sr</th>
                    <th>Industry Name</th>
                    <th>Client Names</th>
                </tr>
                <tr *ngFor="let item of capabilityDetailsForm.get('vendor_industries_clients_attributes')['controls']; let i = index" [formGroupName]="i">
                    <td>{{i+1}}</td>
                    <td class="display-flex-lg">
                        {{item.controls['industry_name'].value}}
                    </td>
                    <td>
                        <input formControlName="client_name" placeholder="eg: Mahindra, Tata, Sony" class="form-control">
                        <div *ngIf="capabilityDetailsFormSubmitted && capabilityDetailsForm.get('vendor_industries_clients_attributes')['controls'][i].get('client_name').errors?.required" class="text-danger">Atleast 1 client is required.</div>
                    </td>
                </tr>
            </table>
        </div>
    </div>

</div>

<h2 class="top-margin machine-details-header">Quality Assurance information</h2>
<div class="col-md-12 blue-box-container">

    <h2 class="machine-details-header blue-color-heading margin-left-zero">Do you have a dedicated quality inspection department?
    </h2>
    <div class="form-check-inline height-auto">
        <label class="form-check-label">
            <input type="radio" class="form-check-input auto-height" name="quality_inspection_department"
              formControlName="quality_inspection_department" [value]="true" (change)= "onChangeQualityInpection(true)">Yes
          </label>
    </div>
    <div class="form-check-inline height-auto">
        <label class="form-check-label">
            <input type="radio" class="form-check-input auto-height" name="quality_inspection_department"
              formControlName="quality_inspection_department" [value]="false" (change)= "onChangeQualityInpection(false)">No
          </label>
    </div> -->

<!-- <h2 class="machine-details-header blue-color-heading margin-left-zero">Total no. of measuring instruments you
          have? <input class="no-of-machine-input" type="number" formControlName="no_of_quality_instruments" min="0"
            max="99999">
          Nos</h2> -->

<!-- <div class="group-gap xs-table-scroll" formArrayName="vendor_quality_instruments_attributes">

        <h2 class="machine-details-header blue-color-heading margin-left-zero">Enter Measuring Instrument details below. </h2>
        <table>
            <tr>
                <th>Sr</th>
                <th>Instrument Name</th>
                <th>Brand Name</th>
                <th>Size/Capacity</th> -->
<!-- <th>No. of Machines</th> -->
<!-- <th>Action</th>
</tr>
<tr *ngFor="let item of capabilityDetailsForm.get('vendor_quality_instruments_attributes')['controls']; let i = index" [formGroupName]="i">

    <td>{{i+1}}</td>
    <td>
        <ng-autocomplete [data]="instruments" [searchKeyword]="keyword" (inputChanged)='onChangeInstrumentSearch($event)' [itemTemplate]="itemTemplate" class="form-control" formControlName="quality_instrument_name" style="width:250px;height:32px">
        </ng-autocomplete>
        <ng-template #itemTemplate let-item>
            <a [innerHTML]="item.display_name"></a>
        </ng-template>
        <span class="" *ngIf="capabilityDetailsFormSubmitted && capabilityDetailsForm.get('vendor_quality_instruments_attributes')['controls'][i].get('quality_instrument_name').errors?.required">
                  <div class="form-error">Name is required</div>
                </span>
    </td>
    <td>
        <ng-autocomplete [data]="brands" [searchKeyword]="keyword" (inputChanged)='onChangeBrandSearch($event)' [itemTemplate]="itemTemplate" class="form-control" formControlName="brand_name" style="width:150px;height:32px">
        </ng-autocomplete>
        <ng-template #itemTemplate let-item>
            <a [innerHTML]="item.display_name"></a>
        </ng-template>
        <span class="" *ngIf="capabilityDetailsFormSubmitted && capabilityDetailsForm.get('vendor_quality_instruments_attributes')['controls'][i].get('brand_name').errors?.required">
                  <div class="form-error">Brand is required</div>
                </span>
    </td>
    <td class="display-flex-lg dimension">
        <input type="number" class="form-control" formControlName="size" placeholder="">
        <span class="" *ngIf="capabilityDetailsFormSubmitted && capabilityDetailsForm.get('vendor_quality_instruments_attributes')['controls'][i].get('size').errors?.required">
                  <div class="form-error">Size is required</div>
                </span>
        <select type="text" class="form-control" formControlName="unit" class="unit-input">
                  <option value="micrometer">um</option>
                  <option value="millimeter">mm</option>
                  <option value="centimeter">cm</option>
                  <option value="meter">m</option>
                  <option value="kilometer">km</option>
                </select>
    </td> -->
<!-- <td>
                      <input type="text" class="form-control" formControlName="quantity">
                  </td> -->
<!-- <td class="center">
    <span class="remove-icon" (click)="removeQualityInstrument(i)">&times;</span>
</td>
</tr>
</table>

<div class="form-row top-margin-sm">

    <div class="col">
        <button type="button" class="btn btn-sm add-machine-data-btn" (click)="addQualityInstrument()"><img
                  class="" src='/assets/images/plus.svg'>Add Quality Instrument</button>
    </div>
</div>

</div>



<div class="machine-details top-margin bottom-margin">
    <div class="col-md-12">
        <h4 class="heading-data">Certifications</h4>
        <ng-multiselect-dropdown [data]="certificates" formControlName="selectedCertificates" [settings]="certificatesDropdownSettings" (onSelect)="onCertificatesSelect($event)" (onDeSelect)="onCertificatesDeselect($event)">
        </ng-multiselect-dropdown>
        <small><a data-toggle="modal" data-target="#newCertificateFormModal" (click)="setNewCertificateForm()"
                class="new-industry-link">Didn't find Certification? Click to add it.</a></small>
    </div>
</div>
<div class="capabilities-info top-margin col-sm-12 no-padding">
    <div *ngIf="documents && documents.length != 0">
        <p *ngFor="let item of documents;" class="overflow-auto">
            {{item.document_file.url}}
            <button type="button" class="btn btn-sm btn-danger" (click)="removeDocument(item.id)"> Delete</button>
        </p>
    </div>
    <div class="form-row top-margin-sm">
        <div class="col">
            <h4 class="blue-color-heading">Attach Certifications</h4>
            <input type="file" multiple (change)="onCertificationDocumentSelect($event)">
        </div>
    </div>
</div>
</div>


<div class="center">
    <button type="submit" class="btn blue-btn top-margin-sm bottom-margin">Save Form</button>
</div>
</form>
</div>
</div> -->

<!-- Form ends -->

<!-- this is machine modal -->
<!-- <div class="modal fade" id="machineFormModal">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title head-title">Machine Details</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="body-data">
                <div class="img-title">
                    <div class="img-head-data" *ngIf="selectedManufacturingTechnology?.name == '3D Printing'">
                        <img src="./assets/images/3dprinitng.png">
                    </div>
                    <div class="img-head-data" *ngIf="selectedManufacturingTechnology?.name == 'CNC Machining'">
                        <img src="./assets/images/cnc_machining.png">
                    </div>
                    <div class="img-head-data" *ngIf="selectedManufacturingTechnology?.name == 'Vacuum Casting'">
                        <img src="./assets/images/vaccum_casting.png">
                    </div>
                    <div class="img-head-data" *ngIf="selectedManufacturingTechnology?.name == 'Sheet Metal Manufacturing'">
                        <img src="./assets/images/sheet_metal.png">
                    </div>
                    <div class="img-head-data" *ngIf="selectedManufacturingTechnology?.name == 'Injection Molding'">
                        <img src="./assets/images/im.png">
                    </div>
                    <div class="img-head-data" *ngIf="selectedManufacturingTechnology?.name == 'Casting/Forging'">
                        <img src="./assets/images/casting.png">
                    </div>
                    <p class="img-flex-text">
                        {{selectedManufacturingTechnology?.name}}
                    </p>
                </div>

                <form [formGroup]="machineForm" (ngSubmit)="submitMachineDetails()">
                    <div class="display-flex-lg col-md-12 no-padding">
                        <div class="form-group col-md-4 col-12  no-padding">
                            <label class="blue-color-heading">Machine Type *</label>
                            <ng-autocomplete [data]="machines" [searchKeyword]="keywordMachine" (inputChanged)='onChangeMachineSearch($event)' (selected)='onMachineSelectSetSpecs($event)' [itemTemplate]="itemMachineTemplate" class="form-control width-100" formControlName="machine_name"
                                style=" width:100%;
                    box-shadow: none;
                  /* border-radius: 23px; */
                  border: none;
                  border: solid 1px #e0e7ff;
                  background-color: rgba(224, 231, 255, 0.2);
                  height: 42px;">
                            </ng-autocomplete>
                            <ng-template #itemMachineTemplate let-item>
                                <a [innerHTML]="item.display_name"></a>
                            </ng-template>
                            <span class="" *ngIf="machineForm.get('machine_name').invalid && machineForm.get('machine_name').touched">
                <div class="form-error" *ngIf="machineForm.get('machine_name').errors?.required">Machine Name is
                  required</div>
              </span>

                        </div>
                        <div class="form-group col-md-4  col-12">
                            <label class="blue-color-heading">Brand Name *</label>
                            <div class="ng-autocomplete">
                                <ng-autocomplete [data]="brands" [searchKeyword]="keyword" (inputChanged)='onChangeBrandSearch($event)' [itemTemplate]="itemTemplate" class="form-control" formControlName="brand_name" style="width:325px;">
                                </ng-autocomplete>
                            </div>
                            <ng-template #itemTemplate let-item>
                                <a [innerHTML]="item.display_name"></a>
                            </ng-template>
                            <span class="" *ngIf="machineForm.get('brand_name').invalid && machineForm.get('brand_name').touched">
                <div class="form-error" *ngIf="machineForm.get('brand_name').errors?.required">Brand Name is
                  required</div>
              </span>
                            <div *ngIf="machineFormSubmitted && mf.brand_name.errors && mf.brand_name.errors.required" class="text-danger">Brand Name is required</div>
                        </div>
                        <div class="form-group col-md-4 col-12 no-padding">
                            <label class="blue-color-heading">Model Number/Type *</label>
                            <input type="text" class="form-control" formControlName="model_number">
                            <span class="" *ngIf="machineForm.get('model_number').invalid && machineForm.get('model_number').touched">
                <div class="form-error" *ngIf="machineForm.get('model_number').errors?.required">Model Number
                  is
                  required</div>
              </span>

                        </div>
                    </div>
                    <div class="display-flex-lg col-md-12 no-padding">
                        <div class="form-group col-md-4 col-12 no-padding">
                            <label class="blue-color-heading">No. of Machines *</label>
                            <input type="number" class="form-control" formControlName="number_of_machines" min="1" max="999">
                            <span class="" *ngIf="machineForm.get('number_of_machines').invalid && machineForm.get('number_of_machines').touched">
                <div class="form-error" *ngIf="machineForm.get('number_of_machines').errors?.required">No. of Machines
                  is
                  required</div>
              </span>

                        </div>
                        <div class="form-group col-md-4 col-12">
                            <label class="blue-color-heading">Monthly Spare Capacity (%) *</label>
                            <input type="number" class="form-control" formControlName="spare_capacity" min="1" max="999">
                            <span class="" *ngIf="machineForm.get('spare_capacity').invalid && machineForm.get('spare_capacity').touched">
                <div class="form-error" *ngIf="machineForm.get('spare_capacity').errors?.required">Spare Capacity is
                  required</div>
                <div *ngIf="machineForm.get('spare_capacity').errors?.min" class="form-error">Cannot be less than 0.
                </div>
                <div *ngIf="machineForm.get('spare_capacity').errors?.max" class="form-error">Cannot be more than 100.
                </div>
              </span>
                        </div>

                    </div>


                    <div *ngIf="selectedMachine.display_name =='Lasercutting'">
                        <div class="display-flex-lg col-md-12 no-padding">
                            <div class="form-group col-md-4 col-12 no-padding">
                                <label class="blue-color-heading">Laser Type</label> -->
<!-- <input type="text" class="form-control" formControlName="laser_type"> -->
<!-- <select class="form-control" formControlName="laser_type">
                  <option value="CO2">CO2</option>
                  <option value="Fibre/Disc">Fibre/Disc</option>
                </select>
                            </div>
                            <div class="form-group col-md-4 col-12">
                                <label class="blue-color-heading">Laser Power(Kilowatt (KW))</label>
                                <input type="number" class="form-control" formControlName="laser_power">
                            </div>
                        </div>
                        <div class="sheet-thickness-data top-margin">

                            <p class="title">Max sheet thickness:</p>
                            <div class="display-flex-lg col-md-12 no-padding">
                                <div class="display-flex-lg form-group col-md-6 col-12 no-padding-left">
                                    <p class="sub-head col-md-3 col-12 no-padding-left">1. Mild Steel:</p>
                                    <div class="input-box col-md-6 col-12">
                                        <input type="text" class="form-control " formControlName="max_sheet_thickness_mild_steel">
                                    </div>
                                    <div class="select-box col-md-3 no-padding-right">
                                        <select class="form-control " formControlName="max_sheet_thickness_mild_steel_unit">
                      <option value="mm" selected>mm</option>
                      <option value="Inches">inch</option>
                    </select>
                                    </div>
                                </div>
                                <div class="display-flex-lg form-group col-md-6 col-12 no-padding-right">
                                    <p class="sub-head col-md-3 col-12 no-padding-left">2.Stainless steel :</p>
                                    <div class="input-box col-md-6 col-12">
                                        <input type="text" class="form-control " formControlName="max_sheet_thickness_stainless_steel">
                                    </div>
                                    <div class="select-box col-md-3 col-12 no-padding-right">
                                        <select name="max_sheet_thickness_stainless_steel_unit" class="form-control" formControlName="max_sheet_thickness_stainless_steel_unit">
                      <option value="mm">mm</option>
                      <option value="Inches">inch</option>
                    </select>
                                    </div>
                                </div>
                            </div>
                            <div class="display-flex-lg col-md-12 col-12 no-padding ">
                                <div class="display-flex-lg form-group col-md-6 col-12 no-padding-left">
                                    <p class="sub-head col-md-3 col-12 no-padding-left">3. Aluminium</p>
                                    <div class="input-box col-md-6 col-12">
                                        <input type="text" class="form-control" formControlName="max_sheet_thickness_aluminium">
                                    </div>
                                    <div class="select-box col-md-3 col-12 no-padding-right">
                                        <select name="max_sheet_thickness_aluminium_unit" class="form-control" formControlName="max_sheet_thickness_aluminium_unit">
                      <option value="mm">mm</option>
                      <option value="Inches">inch</option>
                    </select>
                                    </div>
                                </div>
                                <div class="display-flex-lg form-group col-sm-6 col-12 no-padding-right">
                                    <p class="sub-head col-md-3 col-12 no-padding-left">4. Copper :</p>
                                    <div class="input-box col-md-6 col-12">
                                        <input type="text" class="form-control" formControlName="max_sheet_thickness_copper">
                                    </div>
                                    <div class="select-box col-md-3 col-12 no-padding-right">
                                        <select name="max_sheet_thickness_copper_unit" class="form-control" formControlName="max_sheet_thickness_copper_unit">
                      <option value="mm">mm</option>
                      <option value="Inches">inch</option>
                    </select>
                                    </div>
                                </div>
                            </div>
                            <div class="display-flex-lg col-sm-12 col-12 no-padding">
                                <div class="display-flex-lg form-group col-sm-6 col-12 no-padding-left">
                                    <p class="sub-head col-md-3 col-12 no-padding-left">5. Brass :</p>
                                    <div class="input-box col-md-6 col-12">
                                        <input type="text" class="form-control" formControlName="max_sheet_thickness_brass">
                                    </div>
                                    <div class="select-box col-md-3 col-12 no-padding-right">
                                        <select name="max_sheet_thickness_brass_unit" class="form-control" formControlName="max_sheet_thickness_brass_unit">
                      <option value="mm">mm</option>
                      <option value="Inches">inch</option>
                    </select>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="display-flex-lg col-sm-12 col-12 no-padding top-margin">
                            <div class="display-flex-lg col-sm-7 col-12 no-padding-left">
                                <div class="no-wrap display-flex-lg">
                                    <p class="margin-auto blue-text">Working Range: </p>
                                </div>
                                <div class="display-flex-lg form-group col-sm-5 col-12 no-margin">

                                    <div class="col-md-7 col-12 display-flex-lg no-padding-left">
                                        <p class="working-range-data blue-text">X</p>
                                        <input type="text" class="form-control" formControlName="working_range_x">
                                    </div>
                                    <div class="select-box col-md-5 col-12 no-padding-right">
                                        <select name="working_range_x_unit" class="form-control" formControlName="working_range_x_unit">
                      <option value="mm">mm</option>
                      <option value="Inches">inch</option>
                    </select>
                                    </div>
                                </div>
                                <div class=" display-flex-lg form-group col-sm-5 col-12 no-padding-left no-margin">
                                    <div class="col-md-7 col-12 display-flex-lg no-padding-right">
                                        <p class="working-range-data blue-text">Y</p>
                                        <input type="text" class="form-control" formControlName="working_range_y">
                                    </div>
                                    <div class="select-box col-md-5 col-12 no-padding-right">
                                        <select name="working_range_y_unit" class="form-control" formControlName="working_range_y_unit">
                      <option value="mm">mm</option>
                      <option value="Inches">inch</option>
                    </select>
                                    </div>
                                </div>
                            </div>
                            <div class="display-flex-lg col-md-4 col-md-offset-1 col-12 no-padding-right">
                                <div class="no-wrap display-flex-lg">
                                    <p class="margin-auto blue-text margin-top-xs">Cutting gases:</p>
                                </div>
                                <div class="select-box col-md-3 col-12 no-padding-right">
                                    <select name="cutting_gases" class="form-control" formControlName="cutting_gases">
                    <option value="oxygen">Oxygen</option>
                    <option value="nitrogen">Nitrogen</option>
                    <option value="compressed air">Compressed Air</option>
                  </select>
                                </div>
                            </div>

                        </div>

                        <div class="form-group display-flex-lg top-margin bottom-margin">
                            <h6 class="no-margin blue-text">Marking possible :</h6>
                            &nbsp; &nbsp; &nbsp;
                            <div class="form-check-inline height-auto">
                                <label class="form-check-label">
                  <input type="radio" class="form-check-input auto-height" name="marking_possible"
                    formControlName="marking_possible" [value]="'true'">Yes
                </label>
                            </div>
                            &nbsp; &nbsp;
                            <div class="form-check-inline height-auto ">
                                <label class="form-check-label">
                  <input type="radio" class="form-check-input auto-height" name="marking_possible"
                    formControlName="marking_possible" [value]="'false'">No
                </label>
                            </div>
                        </div>

                    </div>

                    <div *ngIf="selectedMachine.display_name =='Punching'">
                        <div class="display-flex-lg col-sm-12 col-12 no-padding">
                            <div class="form-group col-sm-4  col-12 no-padding-left">
                                <label class="blue-color-heading">Punch Force</label>
                                <input type="text" class="form-control" formControlName="punch_force">
                            </div>
                            <div class="form-group col-sm-8 col-12 no-padding-left">

                                <label class="blue-color-heading">Sheet Thickness (Max)</label>
                                <div class="display-flex-lg col-sm-12 col-12 no-padding">
                                    <div class="col-sm-6 no-padding-left">

                                        <input type="text" class="form-control" formControlName="sheet_thickness">
                                    </div>
                                    <select name="sheet_thickness_unit" class="form-control col-sm-3" formControlName="sheet_thickness_unit">
                    <option value="mm">mm</option>
                    <option value="Inches">inch</option>
                  </select>
                                </div>
                            </div>
                        </div>

                        <div class="display-flex-lg col-sm-12 col-12 no-padding">
                            <div class="form-group col-sm-4 col-12 no-padding-left">
                                <label class="blue-color-heading">Tool Stations</label>
                                <input type="text" class="form-control" formControlName="tool_stations">
                            </div>
                            <div class="form-group col-sm-8 col-12 no-padding-left">
                                <label class="blue-color-heading">Tooling Diameter (Max)</label>
                                <div class="display-flex-lg col-sm-12 col-12 no-padding">
                                    <div class="col-sm-6 no-padding-left">

                                        <input type="text" class="form-control" formControlName="tooling_diameter">
                                    </div>
                                    <select name="tooling_diameter_unit" class="form-control col-sm-3" formControlName="tooling_diameter_unit">
                    <option value="mm">mm</option>
                    <option value="Inches">inch</option>
                  </select>
                                </div>
                            </div>
                        </div>

                        <div class="display-flex-lg col-sm-12 col-12 no-padding">
                            <div class="form-group col-sm-4 col-12 no-padding-left">
                                <label class="blue-color-heading">No. of indexing stations</label>
                                <input type="text" class="form-control" formControlName="no_of_indexing_stations">
                            </div>
                            <div class="form-group col-sm-8 col-12 no-padding-left">
                                <label class="blue-color-heading">Indexing diameter(Max)</label>
                                <div class="display-flex-lg col-sm-12 col-12 no-padding">
                                    <div class="col-sm-6 no-padding-left">

                                        <input type="text" class="form-control" formControlName="indexing_diameter">
                                    </div>
                                    <select name="indexing_diameter_unit" class="form-control col-sm-3" formControlName="indexing_diameter_unit">
                    <option value="mm">mm</option>
                    <option value="Inches">inch</option>
                  </select>
                                </div>
                            </div>
                        </div>

                        <div class="display-flex-lg col-sm-12 col-12 no-padding top-margin">
                            <div class="display-flex-lg col-sm-7 col-12 no-padding-left">
                                <div class="no-wrap display-flex-lg">
                                    <p class="margin-auto blue-text">Working Range: </p>
                                </div>
                                <div class="display-flex-lg form-group col-sm-5 col-12 no-margin">

                                    <div class="col-md-7 display-flex-lg no-padding-left">
                                        <p class="working-range-data blue-text">X</p>
                                        <input type="text" class="form-control" formControlName="working_range_x">
                                    </div>
                                    <div class="select-box col-md-5 no-padding-right">
                                        <select name="working_range_x_unit" class="form-control" formControlName="working_range_x_unit">
                      <option value="mm">mm</option>
                      <option value="Inches">inch</option>
                    </select>
                                    </div>
                                </div>
                                <div class="display-flex-lg form-group col-12 col-sm-5 no-margin">

                                    <div class="col-md-7  display-flex-lg no-padding-left">
                                        <p class="working-range-data blue-text">Y</p>
                                        <input type="text" class="form-control" formControlName="working_range_y">
                                    </div>
                                    <div class="select-box col-md-5 no-padding-right">
                                        <select name="working_range_y_unit" class="form-control" formControlName="working_range_y_unit">
                      <option value="mm">mm</option>
                      <option value="Inches">inch</option>
                    </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="display-flex-lg col-sm-12 col-12 top-margin bottom-margin">
                            <div class="form-group col-sm-3 col-12 no-padding-left">
                                <label class="blue-color-heading">Additional Process Available</label>
                                <select name="additional_process_available" class="form-control" formControlName="additional_process_available">
                  <option value="forming">Forming</option>
                </select>
                            </div>
                            <div class="form-group col-sm-3 col-12">
                                <label class="blue-color-heading">Max Dimensions :</label>
                                <div class="display-flex-lg col-sm-12 no-padding">
                                    <div class="col-sm-6 no-padding-left">
                                        <input type="text" class="form-control " formControlName="forming_max_dimensions">
                                    </div>
                                    <select name="forming_max_dimensions_unit " class="form-control col-sm-6 no-padding-right margin-top-xs" formControlName="forming_max_dimensions_unit">
                    <option value="mm">mm</option>
                    <option value="Inches">inch</option>
                  </select>
                                </div>
                            </div>
                            <div class="form-group col-sm-3 col-12">
                                <label class="blue-color-heading">Max Height :</label>
                                <div class="display-flex-lg col-sm-12 no-padding">
                                    <div class="col-sm-6 no-padding-left">
                                        <input type="text" class="form-control " formControlName="forming_max_height">
                                    </div>

                                    <select name="forming_max_height_unit" class="form-control col-sm-6 no-padding-right margin-top-xs" formControlName="forming_max_height_unit">
                    <option value="mm">mm</option>
                    <option value="Inches">inch</option>
                  </select>
                                </div>
                            </div>
                            <div class="form-group col-sm-3 col-12">
                                <label class="blue-color-heading">Max Angle :</label>
                                <div class="display-flex-lg col-sm-12 no-padding">
                                    <div class="col-sm-6 no-padding-left">
                                        <input type="text" class="form-control margin-top-xs" formControlName="forming_max_angle">
                                    </div>
                                    <select name="forming_max_angle_unit" class="form-control col-sm-6 no-padding-right margin-top-xs" formControlName="forming_max_angle_unit">
                    <option value="Degree">deg</option>
                  </select>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div *ngIf="selectedMachine.display_name =='Combi Machines'">
                        <div class="display-flex-lg col-sm-12 col-12 no-padding">
                            <div class="form-group col-sm-4 col-12 no-padding-left">
                                <label class="blue-color-heading">Laser Type</label> -->
<!-- <input type="text" class="form-control" formControlName="laser_type"> -->
<!-- <select class="form-control" formControlName="laser_type">
                  <option value="CO2">CO2</option>
                  <option value="Fibre/Disc">Fibre/Disc</option>
                </select>
</div>
<div class="form-group col-sm-4 col-12">
    <label class="blue-color-heading">Laser Power(Kilowatt (KW))</label>
    <input type="number" class="form-control" formControlName="laser_power">
</div>
</div>
<div class="sheet-thickness-data top-margin col-12">
    <p class="title">Max sheet thickness:</p>
    <div class="display-flex-lg col-sm-12 col-12 no-padding display-flex-no-wrap">
        <div class="display-flex-lg form-group col-sm-6 no-padding-left">
            <p class="sub-head col-md-3 no-padding-left">1. Mild Steel</p>
            <div class="input-box col-md-6">
                <input type="text" class="form-control" formControlName="max_sheet_thickness_mild_steel">
            </div>
            <div class="select-box col-md-3 no-padding-right">
                <select name="max_sheet_thickness_mild_steel_unit" class="form-control" formControlName="max_sheet_thickness_mild_steel_unit">
                      <option value="mm">mm</option>
                      <option value="Inches">inch</option>
                    </select>
            </div>
        </div>
        <div class="display-flex-lg form-group col-sm-6 no-padding-right">
            <p class="sub-head col-md-3 no-padding-left">2.Stainless steel :</p>
            <div class="input-box col-md-6">
                <input type="text" class="form-control" formControlName="max_sheet_thickness_stainless_steel">
            </div>
            <div class="select-box col-md-3 no-padding-right">
                <select name="max_sheet_thickness_stainless_steel_unit" class="form-control" formControlName="max_sheet_thickness_stainless_steel_unit">
                      <option value="mm">mm</option>
                      <option value="Inches">inch</option>
                    </select>
            </div>
        </div>
    </div>
    <div class="display-flex-lg col-sm-12 no-padding display-flex-no-wrap">
        <div class="display-flex-lg-lg form-group col-sm-6 no-padding-left">
            <p class="sub-head col-md-3 no-padding-left">3. Aluminium</p>
            <div class="input-box col-md-6">
                <input type="text" class="form-control" formControlName="max_sheet_thickness_aluminium">
            </div>
            <div class="select-box col-md-3 no-padding-right">
                <select name="max_sheet_thickness_aluminium_unit" class="form-control" formControlName="max_sheet_thickness_aluminium_unit">
                      <option value="mm">mm</option>
                      <option value="Inches">inch</option>
                    </select>
            </div>
        </div>
        <div class="display-flex-lg-lg form-group col-sm-6 no-padding-left">
            <p class="sub-head col-md-3 no-padding-left">4. Copper :</p>
            <div class="input-box col-md-6">
                <input type="text" class="form-control" formControlName="max_sheet_thickness_copper">
            </div>
            <div class="select-box col-md-3 no-padding-right">
                <select name="max_sheet_thickness_copper_unit" class="form-control" formControlName="max_sheet_thickness_copper_unit">
                      <option value="mm">mm</option>
                      <option value="Inches">inch</option>
                    </select>
            </div>
        </div>
    </div>
    <div class="display-flex-lg-lg col-sm-12 no-padding display-flex-no-wrap">
        <div class="display-flex-lg form-group col-sm-6 no-padding-left">
            <p class="sub-head col-md-3 no-padding-left">5. Brass :</p>
            <div class="input-box col-md-6">
                <input type="text" class="form-control" formControlName="max_sheet_thickness_brass">
            </div>
            <div class="select-box col-md-3 no-padding-right">
                <select name="max_sheet_thickness_brass_unit" class="form-control" formControlName="max_sheet_thickness_brass_unit">
                      <option value="mm">mm</option>
                      <option value="Inches">inch</option>
                    </select>
            </div>
        </div>
    </div>

</div>

<div class="sheet-thickness-data top-margin">
    <p class="title">Max sheet thickness Punching:</p>
    <div class="display-flex-lg col-sm-12 no-padding display-flex-no-wrap">
        <div class="display-flex-lg form-group col-sm-6 no-padding-left">

            <input type="text" class="form-control" formControlName="max_sheet_thickness_punching">
        </div>
        <div class="select-box col-md-3 no-padding-right">
            <select name="max_sheet_thickness_punching_unit" class="form-control" formControlName="max_sheet_thickness_punching_unit">
                    <option value="mm">mm</option>
                    <option value="Inches">inch</option>
                  </select>
        </div>
    </div>
</div>

<div class="display-flex-lg col-sm-12 no-padding top-margin-sm bottom-margin">
    <div class="display-flex-lg col-sm-7 no-padding-left">
        <div class="no-wrap display-flex-lg">
            <p class="margin-auto blue-text">Working Range: </p>
        </div>
        <div class="display-flex-lg form-group col-sm-5 no-margin">

            <div class="col-md-7 display-flex-lg no-padding-left">
                <p class="working-range-data blue-text">X</p>
                <input type="text" class="form-control" formControlName="working_range_x">
            </div>
            <div class="select-box col-md-5 no-padding-right">
                <select name="working_range_x_unit" class="form-control" formControlName="working_range_x_unit">
                      <option value="mm">mm</option>
                      <option value="Inches">inch</option>
                    </select>
            </div>
        </div>
        <div class=" display-flex-lg form-group col-sm-5 no-padding-left no-margin">
            <div class="col-md-7 display-flex-lg no-padding-right">
                <p class="working-range-data blue-text">Y</p>
                <input type="text" class="form-control" formControlName="working_range_y">
            </div>
            <div class="select-box col-md-5 no-padding-right">
                <select name="working_range_y_unit" class="form-control" formControlName="working_range_y_unit">
                      <option value="mm">mm</option>
                      <option value="Inches">inch</option>
                    </select>
            </div>
        </div>
    </div>
</div>
</div>

<div *ngIf="selectedMachine.display_name =='Bending'">


    <div class="form-group col-sm-6 no-padding">
        <p class="blue-color-heading">Bending Length (Max)</p>
        <div class="display-flex-lg col-sm-12 no-padding">
            <div class="col-sm-6 no-padding-left">
                <input type="text" class="form-control" formControlName="bending_length">
            </div>
            <select name="bending_length_unit" class="form-control col-md-3" formControlName="bending_length_unit">
                  <option value="mm">mm</option>
                  <option value="Inches">inch</option>
                </select>
        </div>
    </div>


    <div class="display-flex-lg col-sm-12 no-padding-left">
        <div class="form-group col-sm-4 no-padding-left">
            <label class="blue-color-heading">Free passage between pillars (Max)</label>
            <div class="display-flex-lg col-sm-12 no-padding">
                <div class="col-sm-8 no-padding-left">
                    <input type="text" class="form-control" formControlName="free_passage_between_pillars">
                </div>
                <select name="free_passage_between_pillars_unit" class="form-control col-md-4" formControlName="free_passage_between_pillars_unit">
                    <option value="mm">mm</option>
                    <option value="Inches">inch</option>
                  </select>
            </div>
        </div>
        <div class="form-group col-sm-4">
            <label class="blue-color-heading">Bending aids</label>
            <select name="bending_aids" class="form-control" formControlName="bending_aids">
                  <option value="Hydraulic">Hydraulic</option>
                  <option value="Pneumatic">Pneumatic</option>
                </select>
        </div>
    </div>

    <div class="display-flex-lg col-sm-12 no-padding">
        <div class="display-flex-lg form-group col-sm-6 no-padding top-margin-sm">
            <p class="blue-color-heading relative-data">Support brackets :</p>
            <div class="form-check-inline">
                <label class="form-check-label">
                    <input type="radio" class="form-check-input auto-height" name="support_brackets"
                      formControlName="support_brackets" [value]="true">Yes
                  </label>
            </div>
            <div class="form-check-inline">
                <label class="form-check-label">
                    <input type="radio" class="form-check-input auto-height" name="support_brackets"
                      formControlName="support_brackets" [value]="false">No
                  </label>
            </div>
        </div>
    </div>
</div>

<div *ngIf="selectedMachine.display_name =='Panel Bending'">
    <div class="display-flex-lg col-sm-12">
        <div class="display-flex-lg form-group col-sm-6">
            <label class="blue-color-heading">Total number of panel benders</label>
            <input type="text" class="form-control" formControlName="total_number_of_panel_benders">
        </div>
    </div>
</div>

<div *ngIf="selectedMachine.display_name =='Welding'">
    <div class="display-flex-lg col-sm-12">
        <div class="display-flex-lg form-group col-sm-6">
            <label class="blue-color-heading">Welding Type</label>
            <input type="text" class="form-control" formControlName="welding_type">
        </div>
    </div>
    <div class="display-flex-lg col-sm-12">
        <div class="display-flex-lg form-group col-sm-6">
            <label class="blue-color-heading">Max Seam Length</label>
            <input type="text" class="form-control" formControlName="max_seam_length">
            <select name="max_seam_length_unit" class="form-control" formControlName="max_seam_length_unit">
                  <option value="mm">mm</option>
                  <option value="Inches">inch</option>
                </select>
        </div>
    </div>
</div>

<div *ngIf="selectedMachine.display_name =='Straightening machine'">
    <div class="display-flex-lg col-sm-12">
        <div class="display-flex-lg form-group col-sm-6">
            <label class="blue-color-heading">Nos of rolls</label>
            <input type="text" class="form-control" formControlName="no_of_rolls">
        </div>
    </div>
    <div class="display-flex-lg col-sm-12">
        <div class="display-flex-lg form-group col-sm-6">
            <label class="blue-color-heading">Sheet Width (Max)</label>
            <input type="text" class="form-control" formControlName="max_sheet_width">
            <select name="max_sheet_width_unit" class="form-control" formControlName="max_sheet_width_unit">
                  <option value="mm">mm</option>
                  <option value="Inches">inch</option>
                </select>
        </div>
        <div class="display-flex-lg form-group col-sm-6">
            <label class="blue-color-heading">Sheet thickness (Max ):</label>
            <input type="text" class="form-control" formControlName="sheet_thickness">
            <select name="sheet_thickness_unit" class="form-control" formControlName="sheet_thickness_unit">
                  <option value="mm">mm</option>
                  <option value="Inches">inch</option>
                </select>
        </div>
    </div>
</div>

<div *ngIf="selectedMachine.display_name =='De-burring machine'">
    <div class="display-flex-lg col-sm-12">
        <div class="display-flex-lg form-group col-sm-6">
            <label class="blue-color-heading">Sheet Width (Max)</label>
            <input type="text" class="form-control" formControlName="max_sheet_width">
            <select name="max_sheet_width_unit" class="form-control" formControlName="max_sheet_width_unit">
                  <option value="mm">mm</option>
                  <option value="Inches">inch</option>
                </select>
        </div>
        <div class="display-flex-lg form-group col-sm-6">
            <label class="blue-color-heading">Sheet thickness (Max ):</label>
            <input type="text" class="form-control" formControlName="sheet_thickness">
            <select name="sheet_thickness_unit" class="form-control" formControlName="sheet_thickness_unit">
                  <option value="mm">mm</option>
                  <option value="Inches">inch</option>
                </select>
        </div>
    </div>
</div>

<div class="top-margin-sm specification-details" formArrayName="vom_specifications" *ngIf=" !['Lasercutting', 'Punching', 'Combi Machines', 'Bending', 'Panel Bending', 'Welding', 'Straightening machine', 'De-burring machine'].includes(selectedMachine.display_name)">
    <h6>Specification Details</h6>
    <div class="display-flex-lg col-sm-12" *ngFor="let item of machineForm.get('vom_specifications')['controls']; let i = index" [formGroupName]="i">
        <p class="margin-auto">{{i+1}}.</p>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <div class="form-group col-sm-4">
            <label class="blue-color-heading">Specification *</label>
            <div class="ng-autocomplete">
                <ng-autocomplete [data]="masterSpecs" [searchKeyword]="keyword" [itemTemplate]="itemTemplate" class="form-control" formControlName="master_specification_name" style="width:350px;">
                </ng-autocomplete>
            </div>
            <ng-template #itemTemplate let-item>
                <a [innerHTML]="item.name"></a>
            </ng-template>
            <div *ngIf="machineFormSubmitted && machineForm.get('vom_specifications')['controls'][i].get('master_specification_name').errors?.required" class="text-danger">Specification is required</div>
        </div>
        <div class="form-group col-sm-3">
            <label class="blue-color-heading">Size/Capacity *</label>
            <input type="text" class="form-control" formControlName="machine_capacity">
            <div *ngIf="machineFormSubmitted && machineForm.get('vom_specifications')['controls'][i].get('machine_capacity').errors?.required" class="text-danger">Capacity is required</div>
        </div>
        <div class="form-group col-sm-4 no-padding">
            <label class="blue-color-heading">Unit *</label>
            <div class="ng-autocomplete">
                <ng-autocomplete [data]="machineUnits" [searchKeyword]="keyword" [itemTemplate]="itemTemplate" class="form-control" formControlName="machine_specification_unit_name" style="width:300px;">
                </ng-autocomplete>
            </div>
            <ng-template #itemTemplate let-item>
                <a [innerHTML]="item.name"></a>
            </ng-template>
            <div *ngIf="machineFormSubmitted && machineForm.get('vom_specifications')['controls'][i].get('machine_specification_unit_name').errors?.required" class="text-danger">Unit is required</div>

        </div>
        <div class="col-sm-1 top-margin-sm">

            <button type="button" class="btn none-order-btn btn-sm" (click)="removeMachineSpec(i)">X</button>
        </div>
    </div>

    <div class="text-right">
        <button type="button" class="btn btn-sm add-machine-data-btn btn-sm" (click)="addMachineSpec()"><span
                  class="add-spec-btn">+</span>&nbsp;&nbsp;Add Specification</button>
    </div>

    <div class="form-group col-sm-12 no-padding">
        <label class="blue-color-heading">Machine Speciality if any?</label>
        <textarea type="text" class="form-control" formControlName="machine_speciality"></textarea>
    </div>
</div>

<div class="form-group col-sm-12 no-padding">
    <h6>Geographical location details</h6>
    <label class="blue-color-heading">Select the factory location of this manufacturing machine ?</label> -->
<!-- <ng-multiselect-dropdown
              [data]="availableAddresses"
              formControlName="address_id"
              [settings]="availableAddressDropdownSettings"
            >
            </ng-multiselect-dropdown> -->
<!-- <select formControlName="address_id" class="form-control">
              <option *ngFor="let address of availableAddresses" [value]="address.id">{{address.address}}</option>
            </select>
<div *ngIf="machineFormSubmitted && mf.address_id.errors && mf.address_id.errors.required" class="text-danger">required</div>
</div>

<div class="form-group">
    <h6 class="blue-color-heading">Upload Machine/Factory Images</h6>
    <p *ngFor="let item of machineForm.value.vom_attachments;">
        {{item.attachment_file.url}} -->
<!-- <button type="button" class="btn btn-sm btn-danger" (click)="removeVomAttachment(item.id)"> Delete</button> -->
<!-- </p>
    <div class="top-margin-sm">
        <div class="col">
            <input type="file" multiple (change)="onVomAttachmentSelect($event)">
        </div>
    </div>
</div>

<div class="form-group">
    <h6>Available for Rent</h6>
    <div class="form-check-inline height-auto">
        <label class="form-check-label">
                <input type="radio" class="form-check-input auto-height" name="is_available_for_rent"
                  formControlName="is_available_for_rent" [value]="true">Yes
              </label>
    </div>
    <div class="form-check-inline height-auto">
        <label class="form-check-label">
                <input type="radio" class="form-check-input auto-height" name="is_available_for_rent"
                  formControlName="is_available_for_rent" [value]="false">No
              </label>
    </div>
    <div *ngIf="machineFormSubmitted && mf.is_available_for_rent.errors && mf.is_available_for_rent.errors.required" class="text-danger">required</div>
</div>


<div class="col-sm-12 text-center">
    <button type="submit" class="btn blue-btn top-margin">Save</button>
</div>
</form>
</div>
</div>
</div>
</div> -->

<!-- new print process model -->
<!-- <div class="modal fade" id="newPrintProcessFormModal">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body">
                <form [formGroup]="newPrintProcessForm" *ngIf="!isPrintProcessAdded">
                    <div class="form-group">
                        <button class="close" data-dismiss="modal">&times;</button>
                        <label for="new_print_process_name">Enter Manufacturing Process Name</label>
                        <input type="text" name="new_print_process_name" class="form-control" formControlName="new_print_process_name" autocomplete="off">
                    </div>
                    <button class="btn blue-btn btn-block" (click)='submitNewPrintProcess()' [disabled]="!newPrintProcessForm.valid">Submit</button>
                </form>
                <div *ngIf="isPrintProcessAdded">
                    <button class="close" data-dismiss="modal">&times;</button>
                    <p>Successfully added the new Manufacturing Process!</p>
                </div>
            </div>
        </div>
    </div>
</div> -->

<!-- new industry model -->
<!-- <div class="modal fade" id="newIndustryFormModal">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body">
                <form [formGroup]="newIndustryForm" *ngIf="!isNewIndustryAdded">
                    <div class="form-group">
                        <button class="close" data-dismiss="modal">&times;</button>
                        <label for="new_industry_name">Enter Industry Name</label>
                        <input type="text" name="new_industry_name" class="form-control" formControlName="new_industry_name" autocomplete="off">
                    </div>
                    <button class="btn blue-btn btn-block" (click)='submitNewIndustry()' [disabled]="!newIndustryForm.valid">Submit</button>
                </form>
                <div *ngIf="isNewIndustryAdded">
                    <button class="close" data-dismiss="modal">&times;</button>
                    <p>Successfully added the new Industry Category!</p>
                </div>
            </div>
        </div>
    </div>
</div> -->

<!-- new certificates form model -->
<!-- <div class="modal fade" id="newCertificateFormModal">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body">
                <form [formGroup]="newCertificateForm" *ngIf="!isNewCertificateAdded">
                    <div class="form-group">
                        <button class="close" data-dismiss="modal">&times;</button>
                        <label for="new_certificate_name">Enter Certificate Name</label>
                        <input type="text" name="new_certificate_name" class="form-control" formControlName="new_certificate_name" autocomplete="off">
                    </div>
                    <button class="btn blue-btn btn-block" (click)='submitNewCertificate()' [disabled]="!newCertificateForm.valid">Submit</button>
                </form>
                <div *ngIf="isNewCertificateAdded">
                    <button class="close" data-dismiss="modal">&times;</button>
                    <p>Successfully added the new Certificate Category!</p>
                </div>
            </div>
        </div>
    </div>
</div> -->